import { render, staticRenderFns } from "../views/start.html?vue&type=template&id=373f9e07&"
import script from "../scripts/start.ts?vue&type=script&lang=ts&"
export * from "../scripts/start.ts?vue&type=script&lang=ts&"
import style0 from "./start.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!/home/ujjwal/projects/opensource/idbstudio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VLayout,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/home/ujjwal/projects/opensource/idbstudio/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('373f9e07', component.options)
    } else {
      api.reload('373f9e07', component.options)
    }
    module.hot.accept("../views/start.html?vue&type=template&id=373f9e07&", function () {
      api.rerender('373f9e07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/start.vue"
export default component.exports